export default __webpack_public_path__ + "media/products/wetransfer-3f3ab3dc.png";